import type { UnavailableProduct } from '../../types/products';

interface UnavailableProductCardProps {
  product: UnavailableProduct;
}

export function UnavailableProductCard({ product }: UnavailableProductCardProps) {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-gray-200 bg-white p-3">
      <div className="flex-shrink-0">
        {product.has_image ? (
          <img
            src={product.webp_image_url}
            alt={product.title}
            width={64}
            height={64}
            className="h-16 w-16 rounded object-contain grayscale opacity-60"
          />
        ) : (
          <div className="flex h-16 w-16 items-center justify-center rounded bg-gray-100">
            <i className="fa-solid fa-leaf text-xl text-gray-300" />
          </div>
        )}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-gray-600 truncate">{product.title}</p>
        <p className="text-xs text-gray-400">{product.category_name}</p>
        <span className="mt-1 inline-block rounded bg-gray-100 px-2 py-0.5 text-xs text-gray-500">
          Ya no está disponible
        </span>
      </div>
    </div>
  );
}
